/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import RelationshipCondition from 'cio/app-models/conditions/relationship';

interface ConditionEditorRelationshipInverseArgs {
  condition: RelationshipCondition;
  disabled: boolean;
  disabledOptions?: string[];
  hiddenOptions?: string[];
  size?: string;
}

export default class ConditionEditorRelationshipInverse extends Component<ConditionEditorRelationshipInverseArgs> {
  initialInverseOption = this.selectedValue;

  get disabledOptions() {
    return this.args.disabledOptions ?? [];
  }

  get hiddenOptions() {
    return this.args.hiddenOptions ?? [];
  }

  get selectedValue() {
    return String(this.args.condition.inverse);
  }

  get inverseOptions() {
    let { disabledOptions } = this;

    let options = [
      { value: 'false', label: 'exists', disabled: false },
      { value: 'true', label: 'does not exist', disabled: true },
    ];

    options = options.map((o) => ({
      ...o,
      disabled: disabledOptions.includes(o.value) && o.value !== this.initialInverseOption,
    }));

    options = options.filter((o) => !this.hiddenOptions.includes(o.value));

    return options;
  }

  @action
  onChange(value: string) {
    let { condition } = this.args;
    condition.setProperties({ inverse: value === 'true' });
  }
}
